import Swiper from 'swiper/bundle';

export function initSwiperServices (query = document.querySelectorAll('.blueprintServices.swiper')) {
    for (const servicesSlider of query) {
        new Swiper(servicesSlider, {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoHeight: false,
            autoplay: true,
            loop: true,
            speed: 750,
            breakpoints: {
                0: {
                    slidesPerView: 1.2
                },
                750: {
                    slidesPerView: 2
                },
                1350: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
        });
    }
}